import { render } from "./aIconEditAction.vue?vue&type=template&id=60fcb410"
import script from "./aIconEditAction.vue?vue&type=script&lang=js"
export * from "./aIconEditAction.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__